module.exports = __webpack_public_path__ + "static/img/pro3.3e96b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pro3.jpg
// module id = SAFp
// module chunks = 1